<template>
  <v-card :loading="any_loading">
    <v-card-title test-tag="tag-200">
      <T>Соединение с кассовым сервером</T>
    </v-card-title>
    <v-form ref="form" :disabled="any_loading">
      <v-card-text>
        <CheckBox 
          :original_value="config.use_tcp | orfalse"
          :value="local_config.use_tcp | orfalse"
          :input-value="local_config.use_tcp | orfalse"
          readonly
          @click="toggleTcp"
          style="margin: 0 !important"
          
          :label="$t('Режим разработчика')" 
          :hint="$t('Особый режим работы.<br>Для разработчиков ГК Carbis')"
        />
        <TextField 
          :original_value="config.host"
          v-model="local_config.host"
          
          :rules="[rules.ipaddr]"
          :label="$t('Адрес XML интерфейса')" 
          :hint="$t('IP адрес HTTP XML интерфейса кассового сервера')" 
        />
        <TextField 
          :original_value="config.port"
          v-model="local_config.port"

          type="number" 
          min="0" 
          max="65535" 
          :rules="[rules.port]"
          :label="$t('Порт XML интерфейса')" 
          :hint="$t('Порт HTTP XML интерфейса кассового сервера')" 
        />
        <TextField 
          :original_value="config.user"
          v-model="local_config.user"

          clearable
          key="1" 
          :disabled="local_config.use_tcp" 
          :rules="[rules.require]"
          :label="$t('Логин')" 
          :hint="$t('Логин учетной записи для доступа к HTTP XML интерфейсу кассового сервера')" 
        />
      <!-- </transition-group>
      <transition name="slide"> -->
        <TextField 
          :original_value="config.password"
          v-model="local_config.password"

          key="2" 
          :disabled="local_config.use_tcp"
          password 
          clearable 
          :rules="[rules.require]"
          :label="$t('Пароль')" 
          :hint="$t('Пароль учетной записи для доступа к HTTP XML интерфейсу кассового сервера')" 
        />
      
        <v-dialog v-model="try_tcp" max-width="360">
          <v-card>
            <v-card-title test-tag="tag-201">
              <T>Подтверждение</T>
            </v-card-title>
            <v-form ref="pwd_form" @submit.prevent="tryEnableTcp">
              <v-card-text>
                <TextField 
                  autofocus
                  password 
                  clearable 
                  :label="$t('Код подтверждения')"
                  type="number"
                  :rules="[(v) => !v ? $t('Это обязательное поле') : true]"

                  v-model="tcp_pwd"
                />
              </v-card-text>
              <v-card-actions>
                <v-btn test-tag="tag-198" text color="primary" @click="tryEnableTcp">
                  <v-icon>mdi-save</v-icon>
                  <T>Сохранить</T>
                </v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
        </v-dialog>
      </v-card-text>
      <v-card-actions>
        <v-btn test-tag="tag-199" text color="primary" @click.prevent="checkConnection" :loading="any_loading" >
          <v-icon>mdi-connection</v-icon>
          <T>Проверить соединение</T>
        </v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import CheckBox from '../../common/CheckBox.vue'
import TextField from '../../common/TextField.vue'
import settings_group_mixin from '../settings_group_mixin'

export default {
  mixins: [settings_group_mixin],
  data: () => ({
    local_loading: false,
    try_tcp: false,
    tcp_pwd: ''
  }),
  computed: {
    any_loading(){
      return this.loading || this.local_loading
    }
  },
  filters: {
    orfalse(value) {
      return value || false
    }
  },
  methods: {
    tryEnableTcp(){
      if (this.tcp_pwd === '051791') {
        this.try_tcp = false
        this.tcp_pwd = ''

        this.local_config = {
          ...this.local_config, 
          user: this.config.user,
          password: this.config.password,
          use_tcp: true
        }
      } else {
        this.tcp_pwd = ''
        this.$store.dispatch('throwTimeoutMessage', {
          message_data: this.$t('Некорректный код подтверждения'),
          message_class: 'error'
        })
      }
    },
    toggleTcp(){
      if (!this.local_config.use_tcp) {
        this.try_tcp = true
      } else {
        this.local_config = {...this.local_config, use_tcp: false}
      }
    },
    async checkConnection(){
      this.local_loading = true

      try {
        this.validate()
      } catch(e) {
        this.$store.dispatch('throwTimeoutMessage', {
          message_data: `${this.$t('Ошибка проверки соединения')}:\n${e.message}`,
          message_class: 'error'
        })
      }


      try {
        let r = await this.$store.dispatch('pingDirty', this.local_config)
  
        this.$store.dispatch('throwTimeoutMessage', {
          message_data: `${this.$t('Соединение установлено!')}\n${this.$t('Сервер')}: ${r.mid_name}\n${this.$t('Версия')}: ${r.mid_version}\n${this.$t('Не забудьте сохранить изменения!')}`,
          message_class: 'success'
        })

      } finally {
        this.local_loading = false
      }
      
      // if ((this.local_config.host == this.config.host) && (this.local_config.port == this.config.port) && (this.local_config.use_tcp == this.config.use_tcp)) {
      //   this.$emit('ping')
      // }
    },
    validate() {
      if (!this.$refs.form.validate()) {
        throw new Error(this.$t('Некоторые поля заполнены неверно.\nПожалуйста, исправьте ошибки и повторите попытку.'))
      }
    },
  },
  components:{
    CheckBox,
    TextField
  }
}
</script>